import service from "@/utils/service.js";

const session = {
  // 定义获取会话列表接口
  fetchSessionTitleList: (params) => {
    const url = "/booklib/v2/chat/group";
    const method = "get";
    const config = { url, method, params };
    return service(config);
  },

  // 定义删除会话接口
  deleteSessionTitle: (params) => {
    const url = "/booklib/v2/chat/del";
    const method = "get";
    const config = { url, method, params };
    return service(config);
  },

  // 定义根据会话ID获取会话详情接口
  fetchSessionDetailList: (params) => {
    const url = "/booklib/v2/chat/messageList";
    const method = "get";
    const config = { url, method, params };
    return service(config);
  },

  // 定义会话提问接口
  fetchSessionAnswer: (params) => {
    const url = "/booklib/v2/chat/message";
    const method = "get";
    const timeout = 60000;
    const config = { url, method, params, timeout };
    return service(config);
  },
};

export default session;
